import React from 'react'
import {Link} from 'react-router-dom'
import { ShoppingCart, User } from 'lucide-react'
import styled from 'styled-components'
import { useAuth } from '../../authContext'

export const HeaderContainer = styled.header`
  position: sticky;
  top: 0;
  z-index: 50;
  width: 100%;
  border-bottom: 1px solid #e2e8f0;
  background-color: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(4px);
`

export const HeaderContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  height: 72px;
  align-items: center;
  padding: 0 1rem;
`

export const Logo = styled(Link)`
  font-size: 1.5rem;
  font-weight: bold;
  margin-right: 2rem;
  color: #0f172a;
  text-decoration: none;
`

export const Nav = styled.nav`
  display: flex;
  align-items: center;
  gap: 1.5rem;
  overflow-x: auto;
  white-space: nowrap;
  @media(max-width: 640px) { gap: 0.8rem; }
`

export const NavLink = styled(Link)`
  font-size: 0.875rem;
  font-weight: 500;
  color: #0f172a;
  opacity: ${props => props.active ? 1 : 0.6};
  transition: opacity 0.2s;
  text-decoration: none;
  
  &:hover {
    opacity: 0.8;
  }
`

const navigation = [
  { name: "Programming", href: "/course-library/1" },
  { name: "Graphics", href: "/course-library/2" },
  { name: "Database", href: "/course-library/3" },
  { name: "DevOps", href: "/course-library/4" },
  { name: "Infra", href: "/course-library/5" },
  { name: "내 강의실", href: "/Classroom" },
]

export function Header() {
  const { isLoggedIn } = useAuth();

  return (
    <HeaderContainer>
      <HeaderContent>
        <Logo to="/">AntsNest</Logo>
        <Nav>
          {navigation.map((item) => (
            <NavLink key={item.href} to={item.href}>
              {item.name}
            </NavLink>
          ))}
        </Nav>
        <div style={{ marginLeft: 'auto', display: 'flex', gap: '1rem', alignItems: 'center' }}>
          <NavLink key="Cart" to="/Cart">
            <ShoppingCart size={20} />
          </NavLink>
          <NavLink key={isLoggedIn ? "MyPage" : "Login"} to={isLoggedIn ? "/MyPage" : "/Login"}>
            <User size={20} />
          </NavLink>
        </div>
      </HeaderContent>
    </HeaderContainer>
  )
}
